// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyBRltXF451vigTUrYJSRhZdCg7AQ7GKR7g",
  authDomain: "prowin-properties.firebaseapp.com",
  databaseURL: "https://prowin-properties-default-rtdb.firebaseio.com",
  projectId: "prowin-properties",
  storageBucket: "prowin-properties.appspot.com",
  messagingSenderId: "44640876894",
  appId: "1:44640876894:web:4bfc84160026e6cc8a37cf",
  measurementId: "G-R10QDVKL6K",
};

const app = initializeApp(firebaseConfig);
const db = getDatabase();

export { app, db };
